module.exports = __webpack_public_path__ + "static/media/not-feeling-good-enough.6a95ab01.png";